import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function JobExtensionInProgressProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.viewExtensionDocumentCreationModal()}
          dataTest="job-progression-set-upload-extension-confirmation-button"
        >
          Upload Extension Confirmation
        </Button>
      </CardContent>
    </>
  )
})
